import { render, staticRenderFns } from "./ModalInquiryArchive.vue?vue&type=template&id=21640059&"
import script from "./ModalInquiryArchive.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryArchive.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports